(function() {
  'use strict';
  angular.module('ringbaPortal').directive('gotoSelectNode', gotoSelectNode);

  function gotoSelectNode(
    $timeout,
    $window
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      require: '^ivr',
      link: link,
    };
    return directive;

    function link(scope, element, attributes, $ivrController) {
      let timer;
      const elementSelector = 'ivr-node .panel:not(.goto-source-node)';

      element.on('mouseenter', elementSelector, _handleMouseEnterNode);
      element.on('mouseleave', elementSelector, _handleMouseLeaveNode);
      $window.document.addEventListener('click', _handleDocumentClick, true);
      $window.document.addEventListener('keydown', _bindEscKeyPress, true);
      scope.$on('$destroy', _handleScopeDestroy);

      function _handleDocumentClick(evt) {
        if ($ivrController.isSelectModeActive) {
          if (!$(evt.target).hasClass('ivr-node-overlay') && !$(evt.target).closest('.ivr-node-overlay').length) {
            $ivrController.deactivateSelectMode();
            scope.$digest();
          }
          _removeNodeOverlayActiveClass();
        }
      }

      function _handleMouseEnterNode(evt) {
        if ($ivrController.isSelectModeActive) {
          timer = $timeout(function () {
            // Here evt.target is the .ivr-node-overlay element
            $(evt.currentTarget).addClass('active');
          }, 200);
        }
      }

      function _handleMouseLeaveNode(evt) {
        if ($ivrController.isSelectModeActive && timer) {
          $timeout.cancel(timer);
          timer = null;
          $(evt.currentTarget).removeClass('active');
        }
      }

      function _bindEscKeyPress(evt) {
        if ($ivrController.isSelectModeActive) {
          let isEscape;
          if ('key' in evt) {
            isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
          } else {
            isEscape = (evt.keyCode === 27 || evt.keyCode === 9);
          }
          if (isEscape) {
            $ivrController.deactivateSelectMode();
            scope.$digest();
          }
        }
      }

      function _removeNodeOverlayActiveClass() {
        element.find(elementSelector).removeClass('active');
      }

      function _handleScopeDestroy() {
        element.off('mouseenter');
        element.off('mouseleave');
        $window.document.removeEventListener('keydown', _bindEscKeyPress, true);
        $window.document.removeEventListener('click', _handleDocumentClick, true);
      }

    }
  }

})();
